const { ApplicationContainer } = require('../../../../../containers');
const components = require('../../../../../components');
const actions = require('../../../../../actions');
const selectors = require('../../../../../selectors');
const layouts = require('../../../../../layouts');
const { default: configureStore } = require('../../../../../store/configure_store.js');
const React = require('react');
const ReactDOM = require('react-dom');
const store = configureStore();
store.dispatch({ type: 'RECEIVE_LAYOUTS', layouts });

export const renderReact = () => {
  try {
    ReactDOM.render(
      React.createElement(ApplicationContainer, {
        store,
        components,
        actions,
        selectors,
        layout: layouts.AvantHeader
      }),
      document.querySelector('#react-header')
    );
  } catch (e) {
    // Not a page that wants a new header file.
    // But let's stop just swallowing the error in case
    // a page that needs the header isn't getting it.
    console.log('Header issue:', e);
  }
}
